import { SidebarInterface } from './types';
import strings from '../../resources/strings';
import LogoutIcon from '@mui/icons-material/Logout';
import routes from '../../resources/routes';

const sidebarLogout: SidebarInterface = {
    id: 1,
    title: strings.sidebar.sidebarLogout,
    url: routes.HOME,
    img: LogoutIcon,
};

export default sidebarLogout;
